<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-window v-model="windowPage" style="width: 100%;" touchless>

            <v-window-item :key="0">
                <template v-if="showUserThresholdList">
                <user-threshold-list :userThresholdList="userThresholdList" :thresholdResources="thresholdResources" :lockSave="lockSave" @edit="editUserThreshold" @delete="deleteUserThreshold" :editChange="editChange"></user-threshold-list>
                <v-btn color="#c42111" class="mt-3 mr-3" @click="addNew" :disabled="lockSave">New</v-btn>
                <v-btn color="#c42111" class="mt-3 mr-12" @click="saveClick" :disabled="lockSave || !$store.state.isDirty">
                    Save
                    <v-tooltip bottom color="rgba(48, 48, 48, 1.0)" v-if="$store.state.isDirty">
                        <template v-slot:activator="{ on }">
                            <v-icon class="is-dirty-save-button-icon" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>Pending Changes</span>
                    </v-tooltip>
                </v-btn>

                <v-tooltip bottom color="rgba(48, 48, 48, 1.0)" v-if="$store.state.isDirty">
                    <template v-slot:activator="{ on }">
                        <div style="display: inline-block; position: relative;" v-on="on">
                            <v-btn color="#c42111" class="mt-3 mr-3" @click="editTransferConfiguration" disabled>Edit Transfer Configuration</v-btn>
                        </div>
                    </template>
                    <span>You must save pending changes before editing transfer configurations</span>
                </v-tooltip>
                <v-btn color="#c42111" class="mt-3 mr-3" @click="editTransferConfiguration" :disabled="lockSave" v-else>Edit Transfer Configuration</v-btn>
                </template>

            </v-window-item>

            <v-window-item :key="1">
                <user-threshold-edit v-if="windowPage == 1" :resources="thresholdResources" :userThreshold="selectedUserThresholdClone" @ok="handleOk" @cancel="handleCancel"></user-threshold-edit>
            </v-window-item>

            <v-window-item :key="2">
                <transfer-configuration-list :userThresholdList="userThresholdList" v-if="windowPage == 2" @cancel="windowPage = 0"></transfer-configuration-list>
            </v-window-item>

        </v-window>
    </v-container>
</template>

<script>
import UserThresholdList from "@/components/UserThresholds/UserThresholdList";
import UserThresholdEdit from "@/components/UserThresholds/UserThresholdEdit";
import TransferConfigurationList from "@/components/UserThresholds/TransferConfigurationList";

export default {
    name: 'UserThresholds',
    components: {
        UserThresholdList,
        UserThresholdEdit,
        TransferConfigurationList
    },
    data: () => ({
        windowPage: 0,
        showUserThresholdList: false,
        userThresholdList: [],
        selectedUserThreshold: null,
        selectedUserThresholdClone: null,
        thresholdResources: {
            formats: ["Standard Report", "Selected Metric Over Time"],
            conditions: ["equal to", "not equal to", "less than", "greater than","less than or equal to", "greater than or equal to", "all values"],
            orders: ["Ascending", "Descending"],
            limits: ["All rows", "First 10 rows", "First 20 rows", "First 30 rows", "First 50 rows", "First 100 rows"],
            methods: ["Last Interval", "Average", "Delta", "Delta %"],
            reports: [],
        },
        editChange: false,
        lockSave: false,
        editingNew: false
    }),

    computed: {

    },

    methods: {
        getUserThresholdList: function() {
            let route = (TELSA.apiHost + "userthreshold/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.userThresholdList = result.data.user_threshold_list;
                this.thresholdResources.reports = result.data.thresholds;
                // Check report permissions
                for(let report of this.thresholdResources.reports) {
                    report.disabled = !TELSA.checkPermissionQualifier(this.$store.state.user, `reports/run`, report.name, !this.$store.state.batchConfig.product_perms);
                }
            });
        },

        deleteUserThreshold: function(userThresholdId) {
            for(let [idx, userThreshold] of this.userThresholdList.entries()) {
                if(userThreshold.thres_id == userThresholdId) {
                    this.userThresholdList.splice(idx, 1);
                    break;
                }
            }
        },

        editUserThreshold: function(userThreshold) {
            this.selectedUserThreshold = userThreshold;
            this.selectedUserThresholdClone = JSON.parse(JSON.stringify(userThreshold));
            this.windowPage = 1;
        },

        editTransferConfiguration: function() {
            this.windowPage = 2;
        },

        addNew: function() {
            let newUserThreshold = {
                thres_name: "",
                thres_days_sun: true,
                thres_days_mon: true,
                thres_days_tue: true,
                thres_days_wed: true,
                thres_days_thu: true,
                thres_days_fri: true,
                thres_days_sat: true,
                thres_sort_col: -1,
                thres_intersect: false,
                thres_criteria: [],
                thres_method: 0,
                thres_params: [],
                thres_value: "",
                thres_column: 0,
                thres_method_column: 0,
                thres_filter: "|||",
                thres_test: 0,
                thres_row_limit: 0,
                prev_month: false,
                thres_sort_order: 0,
                user_obj_id: "",
                thres_human_params: [],
                thres_id: 0,
                include_today: false,
                today_only: false
            };
            this.selectedUserThresholdClone = newUserThreshold;
            this.editingNew = true;
            this.windowPage = 1;
        },

        saveClick: function() {
            if(this.$store.state.isDirty) {
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to commit your changes?',
                    type: '',
                    confirmAction: () => { this.save(); }
                });
            }
        },

        save: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "userthreshold/list");
            this.$http.post(route, {args: {lock: this.$store.state.lock, userThresholdList: this.userThresholdList}}).then(response => {
                let result = response.body;
                this.getUserThresholdList().then(r => {
                    this.$store.commit('setIsDirty', false);
                    TELSA.loading(false);
                });
            });
        },

        handleOk: function() {
            if(this.selectedUserThresholdClone.thres_id) {
                this.userThresholdList[this.userThresholdList.findIndex(ut => ut.thres_id == this.selectedUserThresholdClone.thres_id)] = this.selectedUserThresholdClone;
                this.userThresholdList.splice(0,0);
            }
            else {
                if(this.editingNew) {
                    this.userThresholdList.push(this.selectedUserThresholdClone);
                }
                else {
                    // they were editing a UT that is new.
                    let objStr = JSON.stringify(this.selectedUserThreshold);
                    let utIndex = this.userThresholdList.findIndex(ut => JSON.stringify(ut) == objStr);
                    this.userThresholdList[utIndex] = this.selectedUserThresholdClone;
                    this.userThresholdList.splice(0,0);
                }
            }
            this.windowPage = 0;
            this.editChange = !this.editChange;
            this.editingNew = false;
        },

        handleCancel: function() {
            this.windowPage = 0;
            this.selectedUserThreshold = null;
            this.selectedUserThresholdClone = null;
            this.editingNew = false;
        }

    },

    mounted() {
        let promises = [];
        let lockName = `${this.$store.state.user.user_username}:edit_thres`;
        let lockOwner = null;
        promises.push(this.$store.dispatch('getLock', lockName).then(l => {lockOwner = l}));
        promises.push(this.getUserThresholdList());
        Promise.all(promises).then(v => {
            this.showUserThresholdList = true;
            TELSA.loading(false);

            if(lockOwner) {
                // Disable save and let user know page is locked!
                this.lockSave = true;
                this.$store.commit('showConfirmModal', {
                    title: 'Lock Warning',
                    message: `User thresholds are already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: function(){}
                });
            }
        });
    }
};
</script>


<style scoped>

    .data-container {
        display: block;
        padding: 0;
    }

</style>

